import { Component, Input } from "@angular/core";
import { SvgMixinComponent } from "./svg-mixin.component";

export type MedLargeIconMode = "square" | "circle";

const borderRadiusMap = new Map<MedLargeIconMode, string>()
  .set("square", "10px")
  .set("circle", "50%");

const rxMap = new Map<MedLargeIconMode, string>()
  .set("square", "8.5")
  .set("circle", "50%");

@Component({
  selector: "med-svg-wrapper",
  template: "",
})
export class SvgMixinLargeComponent extends SvgMixinComponent {
  private _mode: MedLargeIconMode = "square";
  rx = "8.5";
  protected override _size = "64";

  get styleList() {
    return {
      fontSize: `${this._size}px`,
      borderRadius: borderRadiusMap.get(this._mode),
      boxShadow: "0px .0625em .21875em -.078125em rgba(0, 0, 0, 0.26)",
    };
  }

  @Input() set mode(value: MedLargeIconMode) {
    this.rx = rxMap.get(value) as string;
    this._mode = value;
  }
}
